// form-context.ts file
import { createFormContext } from '@mantine/form';
import { EditableWebinar } from 'redux/webinars/webinarsTypes';

export const [WebinarFormProvider, useWebinarFormContext, useWebinarForm] =
  createFormContext<EditableWebinar>();
